import type { CollectionTicketClaimTypeDTO } from '@/api/trafikportalen/models/collectionTicketClaimTypeDTO';
import type { StudentCollectionType } from '@/helpers/collectionTypes';

export interface TenantConfiguration {
  /** When true, half-product is hidden from imports, exports, org discount codes, and student profile. */
  disableHalfProduct: boolean;
  /** When true, discount code inputs are hidden from organizations, student categories, and exports. */
  disableDiscountCodes: boolean;
  /** Ticket claim type used when creating collection ticket claim periods. */
  claimType: CollectionTicketClaimTypeDTO;
  /** When true, informs the user that school cards are paid for by the organization. */
  schoolCardsArePaid: boolean;
  /** Order of student categories in the periods page and organization student settings. The first is the default period category. */
  studentCategoryOrder: StudentCollectionType[];
}

const DEFAULT_TENANT_CONFIGURATION: TenantConfiguration = {
  disableHalfProduct: false,
  disableDiscountCodes: false,
  claimType: 'partial-payment',
  schoolCardsArePaid: false,
  studentCategoryOrder: [
    'school-student-travel',
    'school-transportation',
    'school-child-and-youth',
  ],
};

const TENANT_CONFIGURATION_OVERRIDES: Record<
  string,
  Partial<TenantConfiguration>
> = {
  ltr: {
    disableHalfProduct: true,
    studentCategoryOrder: [
      'school-child-and-youth',
      'school-student-travel',
      'school-transportation',
    ],
  },
  llt: {
    claimType: 'single',
    disableHalfProduct: true,
    studentCategoryOrder: [
      'school-child-and-youth',
      'school-student-travel',
      'school-transportation',
    ],
  },
  vlt: {
    schoolCardsArePaid: true,
    disableHalfProduct: true,
    disableDiscountCodes: true,
  },
  ltv: { schoolCardsArePaid: true },
  ltn: { schoolCardsArePaid: true },
  ske: {},
};

export const getTenantConfiguration = (
  tenantId: string,
): TenantConfiguration => {
  const key = tenantId.toLowerCase();
  return {
    ...DEFAULT_TENANT_CONFIGURATION,
    ...TENANT_CONFIGURATION_OVERRIDES[key],
  };
};
